import { Phone, Mail, MapPin, Facebook } from "lucide-react";
import { Link } from "react-router-dom";
import { BUSINESS, COVERAGE } from "@/lib/data";
import { WhatsAppIcon } from "@/components/WhatsAppButton";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="pt-16 pb-8 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="grid md:grid-cols-4 gap-10 pb-14">
          <div>
            <img src="/images/logo-full.png" alt="Teign Gas — Service, Repair, Install" className="h-14 w-auto mix-blend-screen mb-5" />
            <p className="text-sm text-neutral-500 leading-relaxed max-w-xs">
              Your local plumber & heating engineer, Gas Safe registered, serving Exeter,
              Newton Abbot, Torquay and all of South Devon. Boiler, fire, cooker and hob
              servicing, 24/7 breakdowns, and general plumbing from toilets, basins and
              sinks to taps and new radiators. Fixed prices, honest diagnostics.
            </p>
          </div>
          <div className="space-y-3.5">
            <p className="font-mono text-xs tracking-[0.25em] text-neutral-500 uppercase mb-4">Talk to us</p>
            <a href={BUSINESS.phoneHref} data-testid="footer-phone-link" className="flex items-center gap-3 text-neutral-300 hover:text-torch transition-colors text-sm">
              <Phone className="w-4 h-4 text-torch" /> {BUSINESS.phone}
            </a>
            <a href={BUSINESS.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="flex items-center gap-3 text-neutral-300 hover:text-torch transition-colors text-sm">
              <span className="w-4 h-4 text-torch"><WhatsAppIcon className="w-4 h-4" /></span> WhatsApp us
            </a>
            <a href={`mailto:${BUSINESS.email}`} data-testid="footer-email-link" className="flex items-center gap-3 text-neutral-300 hover:text-torch transition-colors text-sm">
              <Mail className="w-4 h-4 text-torch" /> {BUSINESS.email}
            </a>
            <a href={BUSINESS.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook-link" className="flex items-center gap-3 text-neutral-300 hover:text-torch transition-colors text-sm">
              <Facebook className="w-4 h-4 text-torch" /> Teign Gas on Facebook
            </a>
          </div>
          <div>
            <p className="font-mono text-xs tracking-[0.25em] text-neutral-500 uppercase mb-4 flex items-center gap-2">
              <MapPin className="w-3.5 h-3.5" /> Areas covered
            </p>
            <div className="flex flex-wrap gap-2">
              {BUSINESS.areas.map((a) => {
                const town = COVERAGE.find((t) => t.name === a);
                const cls = "font-mono text-[10px] tracking-wider uppercase text-neutral-400 border border-neutral-800 px-3 py-1.5 rounded-sm";
                return town ? (
                  <Link key={a} to={`/areas/${town.slug}`} data-testid={`footer-area-${town.slug}`} className={`${cls} hover:border-torch hover:text-torch transition-colors`}>
                    {a}
                  </Link>
                ) : (
                  <span key={a} className={cls}>{a}</span>
                );
              })}
            </div>
          </div>
          <div>
            <p className="font-mono text-xs tracking-[0.25em] text-neutral-500 uppercase mb-4">Explore</p>
            <div className="flex flex-col gap-2.5">
              <Link to="/heat-pumps" data-testid="footer-link-heat-pumps" className="text-sm text-neutral-300 hover:text-torch transition-colors">Heat Pumps</Link>
              <a href="/#landlords" data-testid="footer-link-landlords" className="text-sm text-neutral-300 hover:text-torch transition-colors">Landlords & CP12</a>
              <a href="/#faq" data-testid="footer-link-faq" className="text-sm text-neutral-300 hover:text-torch transition-colors">FAQ</a>
              <Link to="/blog" data-testid="footer-link-blog" className="text-sm text-neutral-300 hover:text-torch transition-colors">Blog & Advice</Link>
              <a href="/#coverage" data-testid="footer-link-coverage" className="text-sm text-neutral-300 hover:text-torch transition-colors">Coverage Map</a>
            </div>
          </div>
        </div>
      </div>

      <div className="select-none pointer-events-none px-2" aria-hidden="true">
        <p className="font-display font-black uppercase text-center leading-none text-stroke-orange text-[18vw] tracking-tight whitespace-nowrap">
          Teign Gas
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 mt-8 pt-6 border-t border-neutral-900 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-mono text-[10px] tracking-wider text-neutral-600 uppercase">
          © {new Date().getFullYear()} Teign Gas · Gas Safe Register #{BUSINESS.gasSafe}
        </p>
        <p className="font-mono text-[10px] tracking-wider text-neutral-600 uppercase">
          If you smell gas, call 0800 111 999 immediately
        </p>
      </div>
    </footer>
  );
};
